export default {
    namespaced: true,
    bookmark: {
      title: "marcador | marcadores",
      categories: "categorias de marcadores",
    },
  };
  